import { useEffect } from 'react';

import { TRACKING_PAGES } from '~common';
import { BAD_STATION_STATUS_PAGE_PATH } from '~configs';
import { useNavigateInApp } from '~hooks/index';
import {
  useEventTrackingContext,
  useStationInformationContext,
} from '~providers';
import { ConnectionState } from '~types/station.type';

export const useOfflineStationEffect = () => {
  const {
    recordPageVisited,
    isStationOfflineRecorded,
    setIsStationOfflineRecorded,
  } = useEventTrackingContext();
  const { stationOnlineStatus, connectionState } =
    useStationInformationContext();
  const navigate = useNavigateInApp();

  useEffect(() => {
    if (!isStationOfflineRecorded && stationOnlineStatus === false) {
      recordPageVisited(TRACKING_PAGES.OFFLINE_STATION);
      setIsStationOfflineRecorded(true);
    }
  }, [
    isStationOfflineRecorded,
    recordPageVisited,
    setIsStationOfflineRecorded,
    stationOnlineStatus,
  ]);

  /**
   * Navigate effect
   * Make sure station offline is recorded before navigation
   * Only navigate when connectionState is NO_INTERNET
   */
  useEffect(() => {
    if (
      isStationOfflineRecorded &&
      stationOnlineStatus === false &&
      connectionState === ConnectionState.NO_INTERNET
    ) {
      navigate(`${BAD_STATION_STATUS_PAGE_PATH}/offline`);
    }
  }, [
    connectionState,
    isStationOfflineRecorded,
    navigate,
    stationOnlineStatus,
  ]);
};
